import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import { ChangeEvent, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import FormFieldWrapper, { BaseFieldProps, FieldTooltipWrapper } from '../FormFieldWrapper';

type Props = BaseFieldProps & {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  ariaLabel?: string;
  checked: boolean;
  children: ReactNode;
  type?: 'checkbox' | 'radio';
  value?: string;
  id?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  inputClassName?: string;
};

export const InputActionStyles = cva('h-4 w-4 border-2 border-inputAction-border cursor-pointer', {
  variants: {
    inputType: {
      radio: 'rounded-full',
      checkbox: 'rounded-sm',
    },
    error: {
      true: '!border-red-500 ring-1 ring-red-500',
    },
  },
  defaultVariants: {
    inputType: 'checkbox',
  },
});

const InputAction = ({
  children,
  value,
  name,
  ariaLabel,
  onChange,
  checked,
  className,
  error,
  touched,
  required,
  type = 'checkbox',
  tooltip,
  id,
  fullWidth,
  disabled,
  inputClassName,
}: Props) => (
  <FormFieldWrapper className={className} error={error} name={name} touched={touched}>
    <div className={twMerge('flex h-fit items-center gap-2', className)}>
      <span className="relative inline-flex flex-shrink-0">
        <input
          aria-label={ariaLabel}
          checked={checked}
          className={twMerge(InputActionStyles({ inputType: type, error: !!error }), inputClassName)}
          disabled={disabled}
          id={id ?? name}
          name={name}
          onChange={onChange}
          type={type}
          value={value}
        />
        {type === 'checkbox' && (
          <span className="inputAction-check-icon pointer-events-none absolute inset-0 hidden items-center justify-center text-white">
            <FontAwesomeIcon className="h-2.5 w-2.5" icon={faCheck} />
          </span>
        )}
      </span>
      <FieldTooltipWrapper tooltip={tooltip}>
        <label className={twMerge('flex items-center', fullWidth ? 'w-full' : '')} htmlFor={id ?? name}>
          {children}
          {required && '*'}
        </label>
      </FieldTooltipWrapper>
    </div>
  </FormFieldWrapper>
);

export default InputAction;
